import { createSlice } from "@reduxjs/toolkit";
import { authenticate, login, signup, logoutThunk } from "./authAPI";

const initialState = {
  user: null,
  authenticated: false,
  signup: {
    loading: false,
    error: null,
    success: null,
  },
  login: {
    loading: false,
    error: null,
    success: null,
  },
  authenticate: {
    loading: false,
    error: null,
  },
  logout: {
    loading: false,
    error: null,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.authenticated = false;
      state.signup.error = null;
      state.signup.success = null;
      state.login.error = null;
      state.login.success = null;
      localStorage.removeItem("user");
    },
    clearError: (state, action) => {
      const { section } = action.payload;
      if (state[section]) {
        state[section].error = null;
      }
    },
    clearSuccess: (state, action) => {
      const { section } = action.payload;
      if (state[section]) {
        state[section].success = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Signup
      .addCase(signup.pending, (state) => {
        state.signup.loading = true;
        state.signup.error = null;
      })
      .addCase(signup.fulfilled, (state, action) => {
        state.signup.loading = false;
        state.user = action.payload.user;
        localStorage.setItem("user", JSON.stringify(action.payload.user));
        state.signup.success = action.payload.msg;
      })
      .addCase(signup.rejected, (state, action) => {
        state.signup.loading = false;
        state.signup.error = action.payload?.msg || 'Signup failed';
      })
      // Login

      .addCase(login.pending, (state) => {
        state.login.loading = true;
        state.login.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.login.loading = false;
        state.user = action.payload.user;
        localStorage.setItem("user", JSON.stringify(action.payload.user));
        state.login.success = action.payload.msg;
      })
      .addCase(login.rejected, (state, action) => {
        state.login.loading = false;
        state.login.error = action.payload?.msg || 'Login failed';
      })

      // Authenticate

      .addCase(authenticate.pending, (state) => {
        state.authenticate.loading = true;
      })
      .addCase(authenticate.fulfilled, (state, action) => {
        state.authenticate.loading = false;
        state.authenticated = action.payload.authenticated;
        if (action.payload.user) {
          state.user = action.payload.user;
          localStorage.setItem("user", JSON.stringify(action.payload.user));
        }
      })
      .addCase(authenticate.rejected, (state, action) => {
        state.authenticate.loading = false;
        state.authenticated = false;
        state.user = null;
        state.authenticate.error = action.payload?.msg || 'Authentication failed';
        localStorage.removeItem('user');
      })

      .addCase(logoutThunk.pending, (state) => {
        state.logout.loading = true;
      })
      .addCase(logoutThunk.fulfilled, (state, action) => {
        state.logout.loading = false;
        state.user = null;
        state.authenticated = false;
        state.signup.error = null;
        state.signup.success = null;
        state.login.error = null;
        state.login.success = null;
        localStorage.removeItem('user');
      })
      .addCase(logoutThunk.rejected, (state, action) => {
        state.logout.loading = false;
        state.logout.error = action.payload?.msg || 'Logout failed';
      })
  },
});

export const { logout, clearError, clearSuccess } = authSlice.actions;
export default authSlice.reducer;
